import { render, staticRenderFns } from "./EditClimateSensitivity.vue?vue&type=template&id=8c25cbf2&"
import script from "./EditClimateSensitivity.vue?vue&type=script&lang=js&"
export * from "./EditClimateSensitivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports